import { FC } from 'react';
import useSetSelectedTab from '@app/core/hooks/useSetSelectedTab';
import { setValuationInputsSelectedTab } from '@app/core/store/ui-values-slice';
import { RouteConstants } from '@app/modules/projects/RouteConstants';
import { Card } from '@app/shared/components/card/Card';
import { useLocale } from '@app/core/hooks/useLocale';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectCapitalStructure } from '@app/core/store/capital-structure-slice-selectors';
import NoResults from '@app/shared/components/no-results/NoResults';
import DiscountRateOverrideTable from './DiscountRateOverrideTable';

const DiscountRateOverride: FC = (): JSX.Element => {
  useSetSelectedTab(RouteConstants.DiscountRateOverride, setValuationInputsSelectedTab);
  const capitalStructure = useAppSelector(selectCapitalStructure);
  const filteredInstruments = Object.values(capitalStructure.instrumentDefinitions).filter(
    (instrument) => instrument.shouldBeValued
  );
  const { l } = useLocale();

  return (
    <Card>
      {filteredInstruments.length ? (
        <div className="main-container-padding-remove">
          <DiscountRateOverrideTable />
        </div>
      ) : (
        <NoResults
          message={l(
            '_AddInstrumentsAndTheyllAutomaticallyShowHereForYouToAddDiscountRateOverrideInformation',
            {
              interpolation: { escapeValue: false },
            }
          )}
        />
      )}
    </Card>
  );
};

export default DiscountRateOverride;
